// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1ZjIz","messages":"Chat_messages__3t_IG","dateDivider":"Chat_dateDivider__2KR89"};